import { getRewardMachineContent } from '@/lib/loyalty-rewards-api';
import { useCallback, useState } from 'react';

export const useRewardMachineContent = (defaultContent: unknown) => {
    const [rewardsMachineContent, setRewardsMachineContent] = useState(defaultContent ?? {});
    const [rewardsMachineContentError, setRewardsMachineContentError] = useState<boolean>(false);

    const fetchRewardsMachineContent = useCallback(async () => {
        setRewardsMachineContentError(false);
        try {
            const content = await getRewardMachineContent();
            setRewardsMachineContent(content?.rewardsMachine);
        } catch {
            setRewardsMachineContentError(true);
        }
    }, []);
    return { rewardsMachineContent, fetchRewardsMachineContent, rewardsMachineContentError };
};
